import { useState } from 'react';
import { apiDriverApp } from '../../../../../../libs/apiDriverApp';

export const useScheduleManager = () => {
   const [loadingManagement, setLoadingManagement] = useState(false);

   const exportSchedules = async () => {
      try {
         setLoadingManagement(true);

         const response = await apiDriverApp.get('/api/hr/calendar/export/', {
            responseType: 'blob', // Especifica que el archivo se recibirá como un blob
         });

         const url = window.URL.createObjectURL(new Blob([response.data]));
         const link = document.createElement('a');
         link.href = url;

         const contentDisposition = response.headers['content-disposition'];
         let fileName = 'AutoScheduleExportFile.xlsx'; // Nombre predeterminado
         if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?="?([^"]+)"?/);
            if (match && match[1]) {
               fileName = match[1];
            }
         }
         link.setAttribute('download', fileName);

         document.body.appendChild(link);
         link.click();

         link.parentNode.removeChild(link);
         window.URL.revokeObjectURL(url);
      } catch (error) {
         console.error('Download error:', error);
      } finally {
         setLoadingManagement(false);
      }
   };

   return {
      exportSchedules,
      loadingManagement,
   };
};
